import React, { Component } from "react";
import Select from "react-select";
import CloseSqaure from "../../../assets/images/auth/close-square.png";
import AddSqaure from "../../../assets/images/auth-home/plus-square.png";
import PollImage from "../../../assets/images/auth-home/chart-img.png";
import Arrowback from "../../../assets/images/auth/arrow-back.png";
import PollInputOption from "./pollInputOption";

const durationData = [
  { value: "1", label: "1 Day" },
  { value: "2", label: "2 Days" },
  { value: "3", label: "3 Days" },
  { value: "4", label: "4 Days" },
  { value: "5", label: "5 Days" },
  { value: "6", label: "6 Days" },
  { value: "7", label: "7 Days" },
  { value: "8", label: "8 Days" },
  { value: "9", label: "9 Days" },
];

const customStyles = {
  control: () => ({
    border: "1px solid #707070",
    borderRadius: 6,
    alignItems: "center",
    backgroundColor: "hsl(0, 0%, 100%)",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: "40px",
    outline: "0!important",
    position: "relative",
    transition: "all 100ms",
    boxSizing: "border-box",
    color: "#707070",
    fontFamily: "Poppins",
    fontSize: 18,
  }),
};

class Poll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      option: "",
      noOfDays: "",
      Options: [
        { id: null, option: "" },
        { id: null, option: "" },
      ],
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  addOption = () => {
    var arr = this.state.Options;
    var new_data = {
      id: null,
      option: "",
    };
    arr.push(new_data);
    this.setState({ Options: arr });
  };

  deleteOption = (id) => {
    var arr = this.state.Options;
    arr.splice(id, 1);
    this.setState({ Options: arr, isOptionAdded: false });
  };

  handleClose = () => {
    this.setState({
      Options: [
        { id: null, option: "" },
        { id: null, option: "" },
      ],
    });
    this.props.closeModal();
  };

  handlePublish = () => {
    alert("Poll Published");
    this.props.closeModal();
  };

  render() {
    return (
      <React.Fragment>
        {this.props.width > 768 ? (
          <div className="d-flex justify-content-end">
            <img
              src={CloseSqaure}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={this.handleClose}
            />
          </div>
        ) : (
          <div className="row align-items-center">
            <div className="col-4">
              <img src={Arrowback} alt="" onClick={this.props.closeModal} />
            </div>
            <div
              className="col-8"
              style={{
                color: "#181818",
                fontSize: 18,
                fontFamily: "Poppins",
                paddingLeft: 0,
              }}
            >
              Create a poll
            </div>
          </div>
        )}
        <div className="mt-4 pt-4">
          {this.props.width > 780 && (
            <div>
              <div className="d-flex justify-content-center pb-2">
                <img src={PollImage} alt="" />
              </div>
              <p className="text-center mb-3">Create a poll</p>
            </div>
          )}
          <div
            className={
              this.props.width > 800
                ? "th-auth-home-popup-poll-box-web py-2 px-3 mb-2"
                : "th-auth-home-popup-poll-box-mob"
            }
          >
            <div className="pt-md-3">
              <div className="row mb-3">
                <div className="col-md-11 col-12">
                  <input
                    type="text"
                    className="form-control th-auth-home-popup-poll-form-control w-100"
                    placeholder="Ask a question"
                    name="question"
                    value={this.state.question}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              {/*  */}
              {this.state.Options.map((item, index) => {
                return (
                  <PollInputOption
                    data={item}
                    width={this.props.width}
                    index={index}
                    handleChange={this.handleChange}
                    onDelete={() => this.deleteOption(index)}
                  />
                );
              })}
              {/*  */}
              <div className="row d-flex align-items-center mb-3">
                <div className="col-md-11 col-12">
                  <Select
                    value={this.state.noOfDays}
                    onChange={(data) => this.setState({ noOfDays: data })}
                    options={durationData}
                    placeholder="Poll duration"
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="p-md-0 px-1">
            <img
              src={AddSqaure}
              alt=""
              style={{ cursor: "pointer", width: 20 }}
              onClick={this.addOption}
            />{" "}
            <span
              style={{
                marginLeft: 2.5,
                fontSize: 14.5,
                fontFamily: "Poppins",
                color: "#707070",
              }}
            >
              {" "}
              Add Option
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-md-end justify-content-center th-auth-popup-btn-wraper">
          {this.props.width > 780 && (
            <div
              className="btn th-auth-popup-btn1 mx-2"
              onClick={this.handleClose}
            >
              Close
            </div>
          )}
          <div className="btn th-auth-popup-btn2" onClick={this.handlePublish}>
            Publish
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Poll;
